<template>
  <ml-tag v-if="map[value]" :type="map[value].type">
    {{ map[value].label }}
  </ml-tag>
</template>
<script>
import MlTag from '@/components/MlTag/index.vue'
import { MapStatus as map } from '../index'

export default {
  name: 'StatusPlcPrice',
  components: { MlTag },
  // eslint-disable-next-line vue/require-prop-types
  props: ['obj'],
  data() {
    return {
      map
    }
  },
  computed: {
    value() {
      let status = 'pending'
      if (parseInt(this.obj.apply_status + '') === 2) {
        return 'changing'
      }
      switch (this.obj.status) {
        case 1:
          status = 'pending'
          break
        case 2:
          status = 'priced'
          break
        default:
          break
      }
      return status
    }
  }
}
</script>
<style scoped lang="scss">

</style>
